export const posts = [
    {
        id: 1,
        title: "The Future of AI in Education",
        description: "Explore how artificial intelligence is revolutionizing the way we learn and teach in modern classrooms.",
        image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=1200&auto=format&fit=crop",
        date: "2024-03-15",
        author: "Dr. Sarah Johnson",
        category: "Technology",
        content: `Artificial Intelligence is transforming education in unprecedented ways. From personalized learning paths to intelligent tutoring systems, AI is making education more accessible and effective than ever before.

In this comprehensive article, we explore:
- How AI is personalizing learning experiences
- The role of machine learning in educational assessment
- Future trends in AI-powered education
- Ethical considerations in AI education

The integration of AI in education is not just about technology; it's about creating more effective and engaging learning environments for students worldwide.`
    },
    {
        id: 2,
        title: "Virtual Reality in Modern Classrooms",
        description: "Discover how VR technology is creating immersive learning experiences for students of all ages.",
        image: "https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?q=80&w=1200&auto=format&fit=crop",
        date: "2024-03-10",
        author: "Michael Chen",
        category: "Innovation",
        content: `Virtual Reality is no longer just for gaming. It's becoming an essential tool in modern education, offering immersive learning experiences that were once impossible.

Key benefits of VR in education:
- Enhanced engagement through immersive experiences
- Safe environment for practical learning
- Global classroom connections
- Improved retention through experiential learning

Learn how schools are implementing VR technology and the impact it's having on student engagement and learning outcomes.`
    },
    {
        id: 3,
        title: "The Rise of Microlearning",
        description: "How bite-sized learning is changing the way we acquire new skills and knowledge.",
        image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1200&auto=format&fit=crop",
        date: "2024-03-05",
        author: "Emma Rodriguez",
        category: "Learning Methods",
        content: `Microlearning is revolutionizing how we approach education and skill development. By breaking down complex topics into small, digestible chunks, learners can absorb information more effectively.

This article covers:
- The science behind microlearning
- Best practices for implementing microlearning
- Success stories from various industries
- Tools and platforms for microlearning

Discover why microlearning is becoming the preferred method for modern learners and how you can implement it in your learning strategy.`
    }
]; 